import { css } from 'styled-components';

// colors
import colors from '../../style/colors';
import { actionLight } from '../../style/theme-helpers';

const variants = {
  default: css`
    border: 1px solid ${colors.gray300};
    background: ${colors.white};
    color: ${colors.gray900};
  `,
  bubblegum: css`
    background: ${colors.lightBubbleGum};
    color: ${colors.darkBubbleGum};
  `,
  emerald: css`
    background: ${colors.lightEmerald};
    color: ${colors.darkEmerald};
  `,
  positive: css`
    background: ${colors.positiveBackground};
    color: ${colors.positiveDark};
  `,
  teal: css`
    background: ${colors.lightTeal};
    color: ${colors.darkTeal};
  `,
  'light-sun': css`
    background: ${colors.lightSun};
    color: ${colors.darkSun};
  `,
  pumpkin: css`
    background: ${colors.lightPumpkin};
    color: ${colors.darkPumpkin};
  `,
  'dark-blue': css`
    background: ${colors.darkBlue};
    color: ${colors.gray100};
  `,
  gray900: css`
    background: ${colors.gray100};
    color: ${colors.gray900};
  `,
  gray300: css`
    background: ${colors.gray300};
    color: ${colors.gray900};
  `,
  sky: css`
    background: ${colors.surfaceSecondary};
    color: ${colors.darkSky};
  `,
  attention: css`
    background: ${colors.attentionBackground};
    color: ${colors.attentionDark};
  `,
  'shadow-white': css`
    background: ${colors.white};
    color: ${colors.gray900};
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.200691);
  `,
  'shadow-white-pill': css`
    background: ${colors.white};
    color: ${colors.gray900};
    box-shadow: 1px 4px 10px 0 rgba(0, 0, 0, 0.07);
    border-radius: 9999px;
  `,
  lavender: css`
    background: ${colors.lightLavender};
    color: ${colors.darkLavender};
  `,
  violet: css`
    background: ${colors.lightViolet};
    color: ${colors.darkViolet};
  `,
  'gray-900-violet': css`
    background: ${colors.gray100};
    color: ${colors.gray900};
    border: 1px solid ${colors.violet};
  `,
  negative: css`
    background: ${colors.negativeBackground};
    color: ${colors.negative};
  `,
  'action-light': css`
    background: ${actionLight};
  `,
  ametystPurple: css`
    background: ${colors.ametystPurple};
    color: ${colors.white};
  `,
  raspberryPink: css`
    background: ${colors.raspberryPink};
    color: ${colors.white};
  `,
  amberGlow: css`
    background: ${colors.amberGlow};
    color: ${colors.white};
  `,
  'coral-light': css`
    background: ${colors.lightCoral};
    color: ${colors.darkCoral};
  `,
  transparent: css`
    background: transparent;
    border: 1px solid ${colors.gray300};
    color: ${colors.gray900};
  `,
  'pumpkin-outline': css`
    background: ${colors.white};
    border: 1px solid ${colors.pumpkin};
    color: ${colors.black};
  `,
};

export const heights = {
  auto: 'auto',
  xxs: '14px',
  xs: '18px',
  sm: '22px',
  md: '30px',
  lg: '40px',
  xl: '48px',
  xxl: '64px',
};

const sizes = {
  auto: css`
    height: ${heights.auto};
    padding: 6px 12px;
    font-size: 0.875rem;
  `,
  xxs: css`
    height: ${heights.xxs};
    line-height: 1;
    padding: 2px 4px;
    font-size: 0.6875rem;
  `,
  xs: css`
    height: ${heights.xs};
    line-height: 1;
    padding: 6px;
    font-size: 0.8125rem;
  `,
  sm: css`
    height: ${heights.sm};
    font-size: 0.875rem;
    padding: 6px 10px;
  `,
  md: css`
    height: ${heights.md};
    padding: 12px;
    font-size: 0.875rem;
  `,
  lg: css`
    height: ${heights.lg};
    padding: 10px 14px;
    font-size: 1rem;
  `,
  xl: css`
    height: ${heights.xl};
    padding: 16px;
    font-size: 1rem;
  `,
  xxl: css`
    height: ${heights.xxl};
    padding: 18px 14px;
    font-size: 1.25rem;
  `,
};

export { variants, sizes };
